import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import AddAcronyms from "./AddAcronyms";
import SplitPane from "react-split-pane";
import { useParams } from "react-router";
import { Spinner, Table } from "react-bootstrap";
import AcronymsFilterData from "./AcronymsFilterData";
import UseToggle from "../../../../../Hooks/UseToggle";
import AcronymsTableProperties from "./AcronymsTableProperties";
import Pagination from "../../../../ETMF/Pagination/Pagination";
import { cdrgStudyServices } from "../../../../../Services/CDISC/cdrgStudyServices";

const AcronymsMetadata = ({ onMouseDown, tableRef }) => {
  const { studyId } = useParams();
  const [loader, setLoader] = useState(false);
  const [acronyms, setAcronyms] = useState("");
  const [translation, setTranslation] = useState("");
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [acronymsData, setAcronymsData] = useState([]);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [acronymsDataId, setAcronymsDataId] = useState("");
  const [highlightedRow, setHighlightedRow] = useState(null);
  const [isOpenProperty, setIsOpenProperty] = useState(false);
  const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getStudyAcrouymsMetadata = async () => {
    let data = await cdrgStudyServices.getStudyAcrouymsMetadata(studyId);
    setAcronymsData(data?.data);
  };

  const updateAcronymsData = (item) => {
    setAcronymsDataId(item);
    setIsFormOpen(true)
  }
  const deleteStudyAcrouymsMetadatas = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Delete this Acronyms?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = await cdrgStudyServices.deleteStudyAcrouymsMetadatas(id, studyId);
        if (data?.statusCode === 200) {
          getStudyAcrouymsMetadata();
        }
      }
    });
  };

  const cleanInputBox = () => {
    setAcronyms("");
    setAcronymsDataId("")
    setTranslation("");
  };

  useEffect(() => {
    getStudyAcrouymsMetadata();
  }, []);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = acronymsData?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(acronymsData?.length / itemsPerPage);

  return (
    <>
      <div className={`code-list-container ${isFullScreen ? "full-screen" : ""}`}>
        <div
          className="hstack justify-content-between w-100 border-bottom toolbar"
          style={{ padding: "4.6px 9px" }}
        >
          {/* <div className="hstack gap-2">
            <button
              className="tabButtons fontSize12 border-0"
              title="Upload New Metadata"
              onClick={() => cleanInputBox()}
            >
              {isFormOpen ? <TbLayoutSidebarRightExpand /> : <AiOutlinePlus />}
            </button>
            <div className="vr"></div>
            <button
              className="tabButtons fontSize12 border-0"
              title="Table Properties"
              onClick={setToggle}
            >
              <LuTableProperties />
            </button>
            <div className="vr"></div>
            <button
              className="tabButtons fontSize12 border-0"
              title="Filter Table Data"
              onClick={setToggle1}
            >
              <CiFilter />
            </button>
          </div> */}

          <div className="hstack gap-2">
            <i
              title={`${isFormOpen ? "Close Form" : "Add New Metadata"}`}
              className={`fa-solid ${isFormOpen ? "fa-square-caret-left" : "fa-square-plus"
                } CP p-1 fontSize12`}
              onClick={() => setIsFormOpen(!isFormOpen)}
              style={{ borderRadius: 3 }}
            ></i>
            <div className="vr"></div>
            <i
              title="Table Properties"
              className="fa-solid fa-table-list CP p-1 fontSize12"
              onClick={setToggle}
              style={{ borderRadius: 3 }}
            ></i>
            <div className="vr"></div>
            <i
              title="Filter Table Data"
              className="fa-solid fa-filter CP p-1 fontSize12"
              onClick={setToggle1}
              style={{ borderRadius: 3 }}
            ></i>
          </div>

          <i
            className={`fa-solid ${isFullScreen ? "fa-minimize" : "fa-maximize"}`}
            title={!isFullScreen ? "Full Mode" : "Original Mode"}
            onClick={toggleFullScreen}
          ></i>
        </div>
        <div className="position-relative">
          <SplitPane
            split="horizontal"
            style={{
              height: isFullScreen ? "calc(100vh - 35px)" : "calc(100vh - 187px)",
            }}
            defaultSize={isOpenProperty ? "40%" : "100%"}
          >
            <SplitPane
              split="vertical"
              minSize={20}
              defaultSize={isFormOpen ? "20%" : "100%"}
            >
              {isFormOpen && (
                <AddAcronyms
                  studyId={studyId}
                  acronyms={acronyms}
                  setAcronyms={setAcronyms}
                  translation={translation}
                  cleanInputBox={cleanInputBox}
                  setTranslation={setTranslation}
                  acronymsDataId={acronymsDataId}
                  setAcronymsDataId={setAcronymsDataId}
                  getStudyAcrouymsMetadata={getStudyAcrouymsMetadata}
                />
              )}
              <>
                {loader ? (
                  <div className="hstack justify-content-center h-100">
                    <Spinner />
                  </div>
                ) : result?.length === 0 ? (
                  <div className="hstack justify-content-center h-100">
                    Data not found!
                  </div>
                ) : (

                  <Table
                    id="resizable-table"
                    ref={tableRef}
                    striped
                    className="m-0 custom-table"
                  >
                    <thead className="thead-sticky">
                      <tr>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 0)}
                          style={{ width: 40 }}
                          className="text-center"
                        >
                          Sr.
                        </th>
                        <th onMouseDown={(e) => onMouseDown(e, 1)}>Acronyms</th>
                        <th onMouseDown={(e) => onMouseDown(e, 2)}>Translation</th>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 3)}
                          style={{ width: 80 }}
                          className="text-center"
                        >
                          Update
                        </th>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 4)}
                          style={{ width: 80 }}
                          className="text-center"
                        >
                          Delete
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {result?.map((item, index) => (
                        <tr key={index}
                          onClick={() => {
                            setHighlightedRow(index);
                          }}
                          className={`position-relative cursor-pointer ${highlightedRow === index && "activeMenu"
                            }`}
                        >
                          <td className="text-center">{index + startIndex + 1}</td>
                          <td>{item.acronyms}</td>
                          <td className="text-wrap">
                            {item.translation}
                          </td>
                          <td className="text-center">
                            <button
                              onClick={() => updateAcronymsData(item)}
                              title="Update Acronys"
                              className="text-white border-success bg-success border-0"
                              style={{ fontSize: 10, borderRadius: 3 }}
                            >
                              Update
                            </button>
                          </td>
                          <td className="cursor-pointer text-center">
                            <button
                              className="text-white border-danger bg-danger border-0"
                              style={{ fontSize: 10, borderRadius: 3 }}
                              title="Delete Acronys"
                              onClick={() => deleteStudyAcrouymsMetadatas(item._id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
                <div className="position-sticky bottom-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={acronymsData?.length}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            </SplitPane>
          </SplitPane>
        </div>

      </div>
      <AcronymsTableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
      />
      <AcronymsFilterData
        Show={!toggle1}
        Hide={setToggle1}
        Title={"Filter Acronyms"}
      />
    </>
  );
};

export default AcronymsMetadata;
